export enum MlTrainingDialogView {
    SELECT_DATASET_METHOD_CLASSES = 'select-dataset-method-classes',
    SET_MODEL_NAME = 'set-model-name',
}
